import { CodellaboratePayload } from './CodellaboratePayload';
import { MonacoEditor } from '../../editor/MonacoEditor';
export class Codellaborate {
    static init() {
        const payload = Codellaborate.getPayloadFromUpload();
        const codeWindow = document.getElementById('code-window');
        if (codeWindow) {
            MonacoEditor.instance(codeWindow, payload.getContent());
        }
        const highlight = document.querySelector('.command-item.highlight');
        if (highlight) {
            highlight.addEventListener('click', () => MonacoEditor.instance().highlightCurrentSelection());
        }
    }
    static getUser() {
        return window.localStorage.getItem('codellaborate_user');
    }
    static getPayloadFromUpload() {
        const uploadUrl = new URL(window.location.href);
        const payloadParam = uploadUrl.searchParams.get('payload');
        if (payloadParam) {
            const decodedPayload = decodeURIComponent(payloadParam);
            return Codellaborate.createPayloadFromUpload(decodedPayload);
        }
        return Codellaborate.DEFAULT_PAYLOAD;
    }
    static createPayloadFromUpload(param) {
        try {
            return new CodellaboratePayload(JSON.parse(param));
        }
        catch (e) {
            return this.DEFAULT_PAYLOAD;
        }
    }
}
Codellaborate.DEFAULT_PAYLOAD = new CodellaboratePayload({
    fileName: 'unkown',
    content: ''
});
